import React, { createContext, useState } from 'react';
import Navbar from '../components/Navbar/Navbar';

export const FichaContext = createContext();

const initialState = {
	convocatoria: {
		idconvocatoria: '',
		pagina: '',
	},
	primera: {
		Pnombre: '',
		Papellido: '',
		identidad: '',
		sexo: '',
		trabaja: '',
		correo: '',
		confcorreo: '',
		fechanaci: null,
		edad: '',
		tcelular: '',
		nacionalidad: '',
		ecivil: '',
		limitacion: '',
		etnia: '',
		Snombre: '',
		Sapellido: '',
		AGraduacion: '',
		tcasa: '',
		otraLimita: '',
	},
	segunda: {
		razones: '',
		jornada: '',
		radiopc: '',
		radiointernet: '',
		radioestudio: '',
		radiotitulo: '',
		radiomatriculado: '',
	},
	tercera: {
		sistema: '',
		sede: '',
		carrera1: '',
		carrera2: '',
		carrera3: '',
	},
};

export const FichaProvider = ({ children }) => {
	const [data, setData] = useState(initialState);

	return (
		<FichaContext.Provider
			value={{
				data,
				setData,
			}}
		>
			<Navbar />
			{children}
		</FichaContext.Provider>
	);
};
